import { Component, EventEmitter, Input, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { GoogleMapsService } from 'src/app/services/google-maps.service';


export interface PlaceIdAddress {
  PlaceId: string;
  Address: string;
}

@Component({
  selector: 'app-direction-google-map-input',
  templateUrl: './direction-google-map-input.component.html',
  styleUrls: ['./direction-google-map-input.component.scss']
})
export class DirectionGoogleMapInputComponent {

  @Input()
  address: string = '';

  @Input()
  latitude: number = 0;

  @Input()
  long: number = 0;

  @Input()
  placeholder: string = ""

  @Output()
  addressEmitter = new EventEmitter()

  @Output()
  latEmitter = new EventEmitter()

  @Output()
  longEmitter = new EventEmitter()

  @Output()
  suggestionEmitter = new EventEmitter()

  @Output() placeIdEmitter = new EventEmitter<PlaceIdAddress>();

  suggestions: any[] = [];

  suggestionSelected: any = null;



  constructor(private googleMapsService: GoogleMapsService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.latitude && this.long && (changes['latitude'] && changes['latitude'].currentValue) || (changes['long'] && changes['long'].currentValue)) {
      this.googleMapsService.getAddressFromLatLong(this.latitude, this.long).then((address: string) => {
        this.address = address;
      })
    }

    if (this.address && (changes['address'] && changes['address'].currentValue)) {
      this.googleMapsService.getLatLongFromAddress(this.address).then((result: any) => {
        this.latitude = result.lat;
        this.long = result.lng
      })
    }
  }

  // Método que se ejecuta cuando se escribe en el input
  onInputChange(): void {
    if (this.address) {
      this.googleMapsService.getAutocompletePredictions(this.address).then((predictions) => {
        this.suggestions = predictions;
      }).catch((error) => {
        console.error(error);
      });
    } else {
      this.suggestions = [];
    }
  }

  // Método que se ejecuta cuando se selecciona una sugerencia
  onSuggestionSelected(suggestion: any): void {
    this.address = suggestion.description;
    this.suggestionSelected = suggestion,
      this.suggestions = [];
    this.getLatLng();
  }

  // Método para obtener latitud y longitud de la dirección
  getLatLng(): void {
    if (this.address) {
      this.googleMapsService.getLatLongFromAddress(this.address).then((result) => {
        this.latitude = result.lat;
        this.long = result.lng;
        this.sendData();
        // this.latLng = result;
        console.log("result: ", result)
      }).catch((error) => {
        console.error(error);
      });
    }
  }

  sendData() {
    this.addressEmitter.emit(this.address);
    this.suggestionEmitter.emit(this.suggestionSelected);
    this.placeIdEmitter.emit(
      { PlaceId: this.suggestionSelected.place_id, Address: this.suggestionSelected.description });
    this.latEmitter.emit(this.latitude);
    this.longEmitter.emit(this.long);
  }
}
